import React from 'react'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import styled from '@emotion/styled'

import SectionIcon from '../icons/SectionIcon'
import BirdIcon from '../icons/BirdIcon'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  h2 {
    color: ${props => props.theme.colors.textBody};
    flex-basis: 30%;
    font-size: 1.846rem;
    font-weight: 600;
    margin: 0 0 0.9rem;
  }
  div {
    margin-top: 0;
  }
  p {
    line-height: 28px;
    margin: 0 0 3.462rem;
  }

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    h2 {
      font-size: 2.5rem;
    }
  }

  @media screen and (min-width: ${props => props.theme.responsive.large}) {
    flex-direction: row;
    margin-top: ${props => props.margin || '164px'};
    h2 {
      font-size: 3.25rem;
      margin: 0;
    }

    .body {
      margin-top: 5rem;
      flex-basis: 80%;
    }
    p {
      font-size: 1.313rem;
      line-height: 40px;
      margin: 0 0 3.75rem;
    }
  }
`

const Title = styled.div`
  @keyframes float {
    0% {
      transform: translatey(0px);
    }
    50% {
      transform: translatey(-20px);
    }
    100% {
      transform: translatey(0px);
    }
  }
  svg {
    display: none;
  }
  @media screen and (min-width: ${props => props.theme.responsive.large}) {
    flex-basis: 30%;
    position: relative;
    svg {
      position: absolute;
      display: block;
      transform: translatey(0px);

      animation: float 8s ease-in-out infinite alternate;
    }

    svg:nth-of-type(1) {
      top: 120px;
      width: 191px;
      animation: float 4s ease-in-out infinite;
    }
    svg:nth-of-type(2) {
      top: 150px;
      width: 227px;
      left: -200px;
      animation: float 8s ease-in-out infinite;
    }
    svg:nth-of-type(3) {
      top: 300px;
      width: 171px;
      animation: float 6s ease-in-out infinite;
    }

    .birdTransform:nth-of-type(1) {
      top: 180px;
      width: 130px;
      left: 100px;
      transform: rotate(20deg);
    }
    .birdTransform:nth-of-type(2) {
      top: 273px;
      width: 167px;
      left: -69px;
    }

    .birdTransform:nth-of-type(3) {
      top: 629px;
      width: 130px;
      left: 34px;
      transform: rotate(7deg);
    }
    .birdTransform:nth-of-type(4) {
      top: 700px;
      width: 171px;
      left: 200px;
      transform: rotate(-10deg);
    }
  }
`

const SectionBottom = styled.div`
  display: none;
  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 60px;
    div {
      flex-basis: auto;
      margin: 0;
    }

    .line {
      width: 100%;
      height: 3px;
      background-color: #000;
      margin-right: 80px;
    }
  }
`

const Section = ({ title, body, children, margin }) => {
  if (children) {
    return (
      <Wrapper margin={margin}>
        <Title>
          <h2>{title} /</h2>

          <BirdIcon />
          <BirdIcon />
          <BirdIcon />
        </Title>
        <div className="body">{children}</div>
      </Wrapper>
    )
  }
  return (
    <Wrapper margin={margin}>
      <Title>
        <h2>{title} /</h2>

        <BirdIcon className="birdTransform" />
        <BirdIcon className="birdTransform" />
        <BirdIcon className="birdTransform" />
        <BirdIcon className="birdTransform" />
      </Title>
      <div className="body">
        {documentToReactComponents(body.json)}

        <SectionBottom>
          <div className="line"></div>
          <div className="sectionIcon">
            <SectionIcon></SectionIcon>
          </div>
        </SectionBottom>
      </div>
    </Wrapper>
  )
}

export default Section
